export const TEST_AUTH_KEY = "__PLAYWRIGHT_AUTH__";

export function isTestAuth(): boolean {
  try {
    return localStorage.getItem(TEST_AUTH_KEY) !== null;
  } catch {
    return false;
  }
}
